import { render, staticRenderFns } from "./WithdrawSetting.vue?vue&type=template&id=334584ce&scoped=true"
import script from "./WithdrawSetting.vue?vue&type=script&lang=js"
export * from "./WithdrawSetting.vue?vue&type=script&lang=js"
import style0 from "./WithdrawSetting.vue?vue&type=style&index=0&id=334584ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334584ce",
  null
  
)

export default component.exports